module.exports = __webpack_public_path__ + "static/media/a29.7c7697cb.pdf";